// @ts-ignore
// @ts-nocheck
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FiMenu } from 'react-icons/fi';
import { IoMdClose } from 'react-icons/io';
import { push as Menu } from 'react-burger-menu';
import { Scrollbars } from 'react-custom-scrollbars';

import ChangeOfUnit from 'components/layout/ChangeOfUnit';
import UserMenuIcon from 'components/Granel/UserMenuIcon';
import NavbarLink from 'components/layout/NavbarLink';
import { pages, socials } from 'components/layout/NavbarNew/pagesMenu';
import NewNotifications from 'newComponents/NewNotifications';
import Notifications from '../Notifications';

import {
  Address,
  BoxAddress,
  BoxNameAddress,
  BoxTwoBars,
  CompanyContainer,
  Content,
  ContentLeft,
  ContentMenuBurger,
  DivOuterContainer,
  IconMenu,
  IconsContainer,
  Logo,
  MenuItemContainer,
  Name,
  NavLogo,
  NavbarComponent,
  SocialContainer,
  SocialIcon,
  TwoBars,
  Divider,
} from './styles';

const styles = {
  bmBurgerButton: {
    position: 'fixed',
    width: 50,
    height: 50,
    left: 7,
    top: 7,
  },
  bmBurgerBars: {
    background: 'transparent',
    outline: 'none',
  },
  bmBurgerBarsHover: {
    background: '#a90000',
  },
  bmCrossButton: {
    height: '24px',
    width: '24px',
    left: '20px',
    top: '25px',
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%',
  },
  bmMorphShape: {
    // fill: "#074F8C"
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)',
  },
} as any;

type DrawerProps = {
  selected?: string;
  openSubMenu?: string;
  children: JSX.Element | JSX.Element[];
};

const Drawer = ({
  selected,
  openSubMenu,
  children,
}: DrawerProps): JSX.Element => {
  const ref = useRef<any>();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [openElement, setOpenElement] = useState<boolean>(false);

  const setCloseMenu = (): void => {
    setIsDrawerOpen(false);
  };

  const handleIsOpen = (): void => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleOutsideClick = (event: any): void => {
    if (ref && !ref?.current?.contains(event.target)) {
      setOpenElement(false);
    } else {
      setOpenElement(true);
    }
  };

  useEffect(() => {
    if (document) {
      document.addEventListener('click', handleOutsideClick, true);
    }
  }, []);

  const MenuBurger = (
    <ContentMenuBurger>
      <IoMdClose />
    </ContentMenuBurger>
  );

  const address = useMemo(() => {
    const customerAddressLine = localStorage.getItem(
      '@UltragazEmpresarial:customerAddressLine'
    );

    if (customerAddressLine) {
      return customerAddressLine
        .toLowerCase()
        .replace(/(?:^|\s)\S/g, function (a) {
          return a.toUpperCase();
        });
    }

    return '';
  }, []);

  const name = useMemo(() => {
    const customerName = localStorage.getItem(
      '@UltragazEmpresarial:customerName'
    );

    if (customerName) {
      return customerName;
    }

    return '';
  }, []);

  return (
    <>
      <Menu
        isOpen={isDrawerOpen}
        onOpen={handleIsOpen}
        onClose={handleIsOpen}
        pageWrapId="page-wrap"
        outerContainerId="outer-container"
        styles={styles}
        width="250px"
        customCrossIcon={MenuBurger}
      >
        <Content>
          <NavLogo>
            <Logo src="/static/ultragaz-logo-white.svg" alt="Ultragaz logo" />
          </NavLogo>

          <CompanyContainer>
            <ChangeOfUnit />
          </CompanyContainer>

          <MenuItemContainer>
            <Scrollbars style={{ height: '100%' }}>
              {pages.map((page: any) => {
                const isSelected = page.slug.includes(selected);
                const Icon = page.icon;
                return (
                  <NavbarLink
                    key={`drawer${page.slug[0]}`}
                    page={page}
                    isSelected={isSelected}
                    selected={selected || ''}
                    Icon={Icon}
                    openSub={openSubMenu || ''}
                    setCloseMenu={setCloseMenu}
                  />
                );
              })}
            </Scrollbars>
          </MenuItemContainer>

          <SocialContainer>
            {socials?.map((social) => (
              <SocialIcon
                key={social?.href}
                href={social?.href}
                target="_blank"
                aria-label={social?.alt}
                rel="external"
              >
                <img src={social?.img} alt={social?.alt} />
              </SocialIcon>
            ))}
          </SocialContainer>
        </Content>
      </Menu>
      <DivOuterContainer id="outer-container">
        <main id="page-wrap">
          <NavbarComponent>
            <ContentLeft>
              <IconMenu>
                <FiMenu />
              </IconMenu>
              <BoxTwoBars openElement={openElement}>
                <TwoBars>{'// '}</TwoBars>
                <BoxNameAddress>
                  <Name>{name}</Name>
                  <BoxAddress>
                    <Address>{address}</Address>
                  </BoxAddress>
                </BoxNameAddress>
              </BoxTwoBars>
            </ContentLeft>
            <IconsContainer>
              <NewNotifications />
              <Divider />
              <UserMenuIcon />
            </IconsContainer>
          </NavbarComponent>
          <div style={{ width: '100%', height: 80 }} />
          {children}
        </main>
      </DivOuterContainer>
    </>
  );
};

Drawer.defaultProps = {
  selected: false,
  openSubMenu: '',
};

export default Drawer;
